
<div
  :class="
    classes(
      n(),
    )
  "
>
  <div
    :class="
      classes(
        n('divider'),
      )
    "
  >
    <Divider
      :layout="'horizontal'"
    />
  </div>
  <slot />
</div>
